module.exports = "/_next/static/images/sekiya_line-fcaa571c89b431569231cf81736a055b.jpg";